module.exports = __webpack_public_path__ + "static/img/mobkast-logo-text.8cb5d3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobkast-logo-text.png
// module id = QdUu
// module chunks = 0